import type React from "react";
import { createContext } from "react";

interface IMeetingModeContext {
  meetingMode: boolean;
  setMeetingMode?: React.Dispatch<React.SetStateAction<boolean>>;
}

const meetingModeContext = createContext<IMeetingModeContext>({
  meetingMode: false,
});

export type { IMeetingModeContext };
export { meetingModeContext };
